import TextEditor from '@/components/common/texteditor/TextEditor.vue'
import UserPicker from '@/components/user/picker/UserPicker.vue'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'
import { required } from 'vuelidate/lib/validators'

const defaultEl = {
  id: null,
  client: null,
  material_group: null,
  status: null,
  done_by_user_id: null,
  date: null,
  fixUntil: null,
  comments: '',
  schedule_to_date_period_id: null
};

export default {
  name: 'AuditEdit',
  data () {
    return {
      editEl: defaultEl,
      loading: false,
      scheduleTo: false
    }
  },
  components: {
    TextEditor,
    UserPicker,
    DatePeriodPicker
  },
  validations: {
    editEl: {
      date: required
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.audit.edit');
      }
      return this.$t('menu.audit.new');
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale, 'disabled', 0);
    },
    auditStatusOptions () {
      return this.$store.getters.getConfigOptions('client_audit_statuses', this.$i18n.locale);
    }
  },
  methods: {
    getAuditStatusClass (statusCode) {
      let resStr = '';
      if (statusCode === this.editEl.status) {
        resStr += 'active';
      }
      if (statusCode === 'CANCEL' || statusCode === 'DELAY') {
        resStr += ' btn-outline-error';
      }
      return resStr;
    },
    show (elData, client) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
        this.editEl.material_group = this.$store.getters.getParamFromConfig('material_groups', this.editEl.material_group_id, 'code');
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
        this.editEl.material_group = this.materialGroupOptions[0].code;
      }
      this.editEl.status = this.$store.getters.getParamFromConfig('client_audit_statuses', this.editEl.status_id, 'code');
      if (client) {
        this.editEl.client = client;
      }
      this.editEl.schedule_to_date_period_id = null;
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        let reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
          if (this.editEl[key] && typeof (this.editEl[key]) === typeof {}) {
            reqData[key] = reqData[key].api_id;
          }
        }
        reqData = { audit: reqData };
        if (this.editEl.status === 'CANCEL' || this.editEl.status === 'DELAY') {
          reqData.auditConfig = { schedule_to_date_period_id: this.editEl.schedule_to_date_period_id };
        }

        const self = this;
        this.ApiRequest.request('audit/edit', this.ApiRequest.REQUEST_POST, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
